import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Icons from './Icons'

const SectionHeaderBase = styled.div`
  display: flex;
  align-content: center;
  padding: ${props => props.theme.spacing(3)}px
    ${props => props.theme.spacing(4)}px;
  font-size: 0.875rem;
  line-height: 1.5rem;
  font-weight: 600;
  text-transform: uppercase;
  color: ${props => props.theme.palette.text.secondary};

  @media (max-width: 768px) {
    display: none;
  }
`
const SectionHeader = props => {
  const { title, icon } = props

  return (
    <SectionHeaderBase>
      <Icons
        icon={icon}
        style={{
          fontSize: 24,
          marginBottom: '6px',
          marginRight: '6px',
        }}
      />
      <span
        style={{
          marginLeft: '8px',
        }}
      >
        {title}
      </span>
    </SectionHeaderBase>
  )
}

SectionHeader.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.string,
}

export default SectionHeader
